export enum ComponentId {
  NUMBER_OF_PARTICIPANTS = "numberOfParticipants",
  ARE_INJURED_PERSONS = "areInjuredPersons",
  GOT_INJURED_PERSONS_DETAILS = "gotInjuredPersonsDetails",
  PERSONS = "persons",
}
